@if (loading) {
  <div class="loading-spinner">
    <mat-spinner [diameter]="50"></mat-spinner>
  </div>
} @else {
  <div class="container-top">
    <div class="flex-item">
      <div class="container-title">
        <div class="back-nav mt-2" (click)="goBack()">
          <mat-icon>chevron_left</mat-icon>
          <span>Return to Orders List</span>
        </div>
        <h1>{{ order.nit }}</h1>
      </div>
    </div>
    <div class="flex-item actions">
      <button class="primary-button" (click)="onCreateTicket()">
        Create Ticket
      </button>
    </div>
  </div>
}

<div class="order-data">
  <div class="flex-item">
    <app-order-details-box
      class="info-box-component"
      title="General Information"
      [data]="generalInfo"
    />
    @if (!datesInCenter) {
      <app-order-dates-box class="info-box-component" [dates]="keyDates" />
    }
  </div>
  <div class="flex-item">
    @if (basicServiceInfo?.length > 0) {
      <app-order-details-box
        class="info-box-component"
        title="Basic Service Information"
        [data]="basicServiceInfo"
      />
    }
    @if (datesInCenter) {
      <app-order-details-box
        class="info-box-component"
        title="Circuit Order Specifics"
        [data]="circuitOrdersInfo"
      />
    } @else {
      <app-order-dates-box class="info-box-component" [dates]="keyDates" />
    }
  </div>
  <div class="flex-item last-column">
    <app-order-contacts-box class="info-box-component" [data]="contactsInfo" />
  </div>
</div>
